import { render, staticRenderFns } from "./voters.vue?vue&type=template&id=d8fc27fa&"
import script from "./voters.vue?vue&type=script&lang=js&"
export * from "./voters.vue?vue&type=script&lang=js&"
import style0 from "./voters.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports